<template>
  <div>

    <div class="box">
      <div class="flex flex-wrap items-center">
        <!-- <filtering-toggle-button :filtering="filtering" /> -->

        <div class="flex-grow mb-1">
          <list-search v-model="searchInput" @search="getSuppliers" />
          <p class="text-xs mt-0 ml-1" v-if="query.search !== ''">
            Searching for <span class="text-red-500 font-bold">{{ query.search }}</span>
          </p>
        </div>

        <div class="flex">
          <div
            v-if="hasPermission('supplier.create')"
            class="btn btn-purple text-sm mr-2 h-10 flex items-center px-3 mb-1"
            @click="$router.push('/supplier/create/accounts')"
          >
            <i class="fas fa-plus"></i>
            <span class="ml-2">New supplier</span>
          </div>

          <button
            v-if="hasPermission('supplier.export')"
            type="button"
            class="btn btn-green text-sm px-3 flex items-center mb-1"
            :disabled="!exportFile.supplier.enabled"
            @click="exportSuppliers"
          >
            <i class="fas fa-spinner fa-spin mr-2" v-if="!exportFile.supplier.enabled"></i>
            <span>Export</span>
          </button>

          <button class="btn w-10 h-10 flex items-center justify-center focus:outline-none hover:text-green-500 mb-1" @click="getSuppliers">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-wrap">
        <div
          class="w-full lg:w-2/12 pr-2 pt-4 border-r border-theme-darker"
          v-show="filtering.active"
        >
          <supplier-filters
            :filters.sync="filters"
            @updated="getSuppliers"
            @has-changes="filtering.hasChanges = $event"
          />
        </div>

        <div class="w-full overflow-x-auto" :class="{ 'lg:w-10/12': filtering.active}">
          <p class="text-lg text-center my-12" v-if="!hasSuppliers">No data to display</p>
          <div v-else>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Unpaid total</th>
                  <th>Created at</th>
                  <th v-if="hasAnyOfPermissions(['supplier.view', 'supplier.delete'])">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(supplier, i) in suppliers" :key="i">
                  <td>{{ supplier.id }}</td>
                  <td>{{ supplier.first_name }} {{ supplier.last_name }}</td>
                  <td>{{ supplier.email }}</td>
                  <td>
                    <span class="text-red-500" v-if="supplier.unpaid_total">{{ $formatMoney(supplier.unpaid_total) }}</span>
                  </td>
                  <td>{{ $moment(supplier.created_at).format(config.dateTimeFormats.display) }}</td>
                  <td v-if="hasAnyOfPermissions(['supplier.view', 'supplier.delete'])">
                    <div class="flex">
                      <a
                        class="hover:text-theme-darker text-base cursor-pointer p-2"
                        @click.stop="$router.push('/supplier/details/' + supplier.id)"
                        v-if="hasPermission('supplier.view')"
                      ><i class="fas fa-info"></i></a>
                      <a
                        class="hover:text-theme-darker text-base cursor-pointer p-2"
                        @click.stop="deleteSupplier(supplier.id)"
                        v-if="hasPermission('supplier.delete')"
                      ><i class="fas fa-trash"></i></a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="w-full flex justify-center">
          <pagination-component
            class="mt-8"
            v-if="hasSuppliers && pagination.totalRows / pagination.perPage > 1"
            v-model="pagination.currentPage"
            :total-rows="pagination.totalRows"
            :rows-per-page="pagination.perPage"
          />
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const ListSearch = resolve => require(['@/components/ListSearch'], resolve)
const PaginationComponent = resolve => require(['@/components/Pagination'], resolve)
// const FilteringToggleButton = resolve => require(['@/components/filters/FilteringToggleButton'], resolve)
const SupplierFilters = resolve => require(['@/components/filters/Filters'], resolve)

export default {
  name: 'supplier-list',
  components: {
    // FilteringToggleButton,
    ListSearch,
    PaginationComponent,
    SupplierFilters,
  },
  data() {
    return {
      suppliers: [],
      searchInput: '',
      query: {
        search: '',
      },
      exportFile: {
        supplier: {
          enabled: true,
        }
      },
      filtering: {
        active: false,
        hasChanges: false,
      },
      filters: {},
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 0,
      }
    }
  },
  watch: {
    'pagination.currentPage'() {
      this.getSuppliers()
    },
    searchInput(i) {
      if (i === '' && this.query.search !== '') {
        this.getSuppliers()
      }
    }
  },
  computed: {
    hasSuppliers() {
      return Object.entries(this.suppliers).length > 0
    },
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
      hasAnyOfPermissions: 'user/hasAnyOfPermissions',
    })
  },
  mounted() {
    this.getSuppliers()
  },
  methods: {
    exportSuppliers() {
      this.exportFile.supplier.enabled = false
      axios.get('suppliers/export', {
        params: {
          search: this.searchInput
        },
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.$downloadFile(response)
          this.exportFile.supplier.enabled = true
        })
    },
    deleteSupplier(supplierID) {
      this.$swal.fire({
        title: 'Delete supplier',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('suppliers/' + supplierID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.getSuppliers()
              })
          }
        })
    },
    getSuppliers() {
      axios.get('suppliers', {params:{
        page: this.pagination.currentPage,
        search: this.searchInput,
      }})
        .then(response => {
          if (response.data) {
            const res = response.data
            const suppliers = res.data
            this.pagination.perPage = res.per_page
            this.pagination.totalRows = res.total

            if (suppliers.length) {
              axios.post('reports/suppliers/unpaid-total', {
                suppliers: suppliers.map(s => s.id)
              })
                .then(response => {
                  const totals = response.data
                  for (let i in totals) {
                    for (let j in suppliers) {
                      if (totals[i].id === suppliers[j].id) {
                        this.$set(suppliers[j], 'unpaid_total', totals[i].unpaid_total)
                      }
                    }
                  }
                  // We can set this.suppliers here and it will prevent the delayed display
                  // of unpaid_total but it will also delay the whole table.
                })
            }
            this.suppliers = Object.assign([], suppliers)

            this.query.search = this.searchInput
          }
        })
    }
  }
}
</script>
